import { __extends } from "tslib";
import { DiffuseBasicMethod, _Shader_DiffuseBasicMethod } from './DiffuseBasicMethod';
/**
 * DiffuseWrapMethod is an alternative to DiffuseBasicMethod in which the light is allowed to be "wrapped around" the normally dark area, to some extent.
 * It can be used as a crude approximation to Oren-Nayar or simple subsurface scattering.
 */
var DiffuseWrapMethod = /** @class */ (function (_super) {
    __extends(DiffuseWrapMethod, _super);
    /**
     * Creates a new DiffuseWrapMethod object.
     * @param wrapFactor A factor to indicate the amount by which the light is allowed to wrap
     */
    function DiffuseWrapMethod(wrapFactor) {
        if (wrapFactor === void 0) { wrapFactor = .5; }
        var _this = _super.call(this) || this;
        _this.wrapFactor = wrapFactor;
        return _this;
    }
    Object.defineProperty(DiffuseWrapMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return DiffuseWrapMethod.assetType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiffuseWrapMethod.prototype, "wrapFactor", {
        /**
         * A factor to indicate the amount by which the light is allowed to wrap.
         */
        get: function () {
            return this._wrapFactor;
        },
        set: function (value) {
            this._wrapFactor = value;
            this._wrapFactor = 1 / (value + 1);
            this.invalidate();
        },
        enumerable: false,
        configurable: true
    });
    DiffuseWrapMethod.assetType = '[asset DiffuseWrapMethod]';
    return DiffuseWrapMethod;
}(DiffuseBasicMethod));
export { DiffuseWrapMethod };
import { ShaderBase } from '@awayjs/renderer';
/**
 * _Shader_DiffuseWrapMethod is an alternative to _Shader_DiffuseBasicMethod in which the light is allowed to be "wrapped around" the normally dark area, to some extent.
 * It can be used as a crude approximation to Oren-Nayar or simple subsurface scattering.
 */
var _Shader_DiffuseWrapMethod = /** @class */ (function (_super) {
    __extends(_Shader_DiffuseWrapMethod, _super);
    /**
     * Creates a new _Shader_DiffuseWrapMethod object.
     */
    function _Shader_DiffuseWrapMethod(method, shader) {
        return _super.call(this, method, shader) || this;
    }
    /**
     * @inheritDoc
     */
    _Shader_DiffuseWrapMethod.prototype._cleanCompilationData = function () {
        _super.prototype._cleanCompilationData.call(this);
        this._wrapDataRegister = null;
    };
    /**
     * @inheritDoc
     */
    _Shader_DiffuseWrapMethod.prototype._getFragmentPreLightingCode = function (registerCache, sharedRegisters) {
        var code = _super.prototype._getFragmentPreLightingCode.call(this, registerCache, sharedRegisters);
        this._pIsFirstLight = true;
        this._wrapDataRegister = registerCache.getFreeFragmentConstant();
        this._wrapDataIndex = this._wrapDataRegister.index * 4;
        return code;
    };
    /**
     * @inheritDoc
     */
    _Shader_DiffuseWrapMethod.prototype._getFragmentCodePerLight = function (lightDirReg, lightColReg, registerCache, sharedRegisters) {
        var code = '';
        var t;
        // write in temporary if not first light, so we can add to total diffuse colour
        if (this._pIsFirstLight) {
            t = this._totalLightColorReg;
        }
        else {
            t = registerCache.getFreeFragmentVectorTemp();
            registerCache.addFragmentTempUsages(t, 1);
        }
        code += 'dp3 ' + t + '.x, ' + lightDirReg + '.xyz, ' + sharedRegisters.normalFragment + '.xyz\n' +
            'add ' + t + '.y, ' + t + '.x, ' + this._wrapDataRegister + '.x\n' +
            'mul ' + t + '.y, ' + t + '.y, ' + this._wrapDataRegister + '.y\n' +
            'sat ' + t + '.w, ' + t + '.y\n' +
            'mul ' + t + '.xz, ' + t + '.w, ' + lightDirReg + '.wz\n';
        if (this._modulateFunction != null)
            code += this._modulateFunction(lightDirReg, registerCache, sharedRegisters);
        code += 'mul ' + t + ', ' + t + '.x, ' + lightColReg + '\n';
        if (!this._pIsFirstLight) {
            code += 'add ' + this._totalLightColorReg + '.xyz, ' + this._totalLightColorReg + '.xyz, ' + t + '.xyz\n';
            registerCache.removeFragmentTempUsage(t);
        }
        this._pIsFirstLight = false;
        return code;
    };
    /**
     * @inheritDoc
     */
    _Shader_DiffuseWrapMethod.prototype._activate = function () {
        _super.prototype._activate.call(this);
        if (this._invalid) {
            var index = this._wrapDataIndex;
            var data = this._shader.fragmentConstantData;
            data[index] = this._method.wrapFactor;
            data[index + 1] = 1 / (this._method.wrapFactor + 1);
        }
    };
    return _Shader_DiffuseWrapMethod;
}(_Shader_DiffuseBasicMethod));
export { _Shader_DiffuseWrapMethod };
ShaderBase.registerAbstraction(_Shader_DiffuseWrapMethod, DiffuseWrapMethod);
